import { challengeTypes } from '../../../../utils/challenge-types';
import {
  completedChallengesSelector,
  allChallengesInfoSelector,
  isSignedInSelector
} from '../../../redux/selectors';
import {
  getCurrentBlockIds,
  getCompletedChallengesInBlock,
  getCompletedPercentage
} from '../../../utils/get-completion-percentage';
import { ns } from './action-types';

export const challengeFilesSelector = state => state[ns].challengeFiles;
export const challengeMetaSelector = state => state[ns].challengeMeta;
export const challengeTestsSelector = state => state[ns].challengeTests;
export const consoleOutputSelector = state => state[ns].consoleOut;
export const completedChallengesIdsSelector = state =>
  completedChallengesSelector(state).map(node => node.id);
export const isChallengeCompletedSelector = state => {
  const completedChallenges = completedChallengesSelector(state);
  const { id: currentChallengeId } = challengeMetaSelector(state);
  return completedChallenges.some(({ id }) => id === currentChallengeId);
};
export const isCodeLockedSelector = state => state[ns].isCodeLocked;
export const isCompletionModalOpenSelector = state =>
  state[ns].modal.completion;
export const isHelpModalOpenSelector = state => state[ns].modal.help;
export const isVideoModalOpenSelector = state => state[ns].modal.video;
export const isResetModalOpenSelector = state => state[ns].modal.reset;
export const isShortcutsModalOpenSelector = state => state[ns].modal.shortcuts;

export const isLimitedAccessModalOpenSelector = state =>
  state[ns].modal.limitedAccess;
export const isCongratsCompleteAccessOpenSelector = state =>
  state[ns].modal.congratsCompleteAccess;
export const isVerifyPaidCourseOpenSelector = state =>
  state[ns].modal.verifyPaidCourse;
export const isNacionalCertificateOpenSelector = state => {
  return state[ns].modal.nacionalCertificate;
};
export const isConcludedCertificateOpenSelector = state => {
  return state[ns].modal.concludedCertificate;
};
export const isDiscordCommunityOpenSelector = state => {
  return state[ns].modal.discordCommunity;
};

export const isSctecCongratsOpenSelector = state => {
  return state[ns].modal.sctecCongrats;
};

export const isNotAllowedChallengeModalOpenSelector = state =>
  state[ns].modal.notAllowedChallenge;

export const isCompletionQuizModalOpenSelector = state =>
  state[ns].modal.completionQuiz;

export const isResettingSelector = state => state[ns].isResetting;

export const isBuildEnabledSelector = state => state[ns].isBuildEnabled;
export const successMessageSelector = state => state[ns].successMessage;

export const projectFormValuesSelector = state =>
  state[ns].projectFormValues || {};
export const isAdvancingToChallengeSelector = state => state[ns].isAdvancing;
export const portalDocumentSelector = state => state[ns].portalWindow?.document;
export const portalWindowSelector = state => state[ns].portalWindow;

export const challengeDataSelector = state => {
  const { challengeType } = challengeMetaSelector(state);
  let challengeData = { challengeType };
  if (
    challengeType === challengeTypes.js ||
    challengeType === challengeTypes.jsProject
  ) {
    challengeData = {
      ...challengeData,
      challengeFiles: challengeFilesSelector(state)
    };
  } else if (challengeType === challengeTypes.backend) {
    const { solution: url = {} } = projectFormValuesSelector(state);
    challengeData = {
      ...challengeData,
      url
    };
  } else if (
    challengeType === challengeTypes.backEndProject ||
    challengeType === challengeTypes.pythonProject
  ) {
    const values = projectFormValuesSelector(state);
    const { solution: url } = values;
    challengeData = {
      ...challengeData,
      ...values,
      url
    };
  } else if (challengeType === challengeTypes.frontEndProject) {
    challengeData = {
      ...challengeData,
      ...projectFormValuesSelector(state)
    };
  } else if (
    challengeType === challengeTypes.html ||
    challengeType === challengeTypes.modern ||
    challengeType === challengeTypes.multifileCertProject
  ) {
    const { required = [], template = '' } = challengeMetaSelector(state);
    challengeData = {
      ...challengeData,
      challengeFiles: challengeFilesSelector(state),
      required,
      template
    };
  }
  return challengeData;
};

export const currentBlockIdsSelector = state => {
  const { block, certification, challengeType } = challengeMetaSelector(state);
  const allChallengesInfo = allChallengesInfoSelector(state);

  return getCurrentBlockIds(
    allChallengesInfo,
    block,
    certification,
    challengeType
  );
};

export const completedChallengesInBlockSelector = state => {
  const completedChallengesIds = completedChallengesIdsSelector(state);
  const currentBlockIds = currentBlockIdsSelector(state);
  const { id } = challengeMetaSelector(state);

  return getCompletedChallengesInBlock(
    completedChallengesIds,
    currentBlockIds,
    id
  );
};

export const completedPercentageSelector = state => {
  const isSignedIn = isSignedInSelector(state);
  if (isSignedIn) {
    const completedChallengesIds = completedChallengesIdsSelector(state);
    const { id } = challengeMetaSelector(state);
    const currentBlockIds = currentBlockIdsSelector(state);
    const completedPercentage = getCompletedPercentage(
      completedChallengesIds,
      currentBlockIds,
      id
    );
    return completedPercentage;
  } else return 0;
};

export const isBlockNewlyCompletedSelector = state => {
  const completedPercentage = completedPercentageSelector(state);
  const completedChallengesIds = completedChallengesIdsSelector(state);
  const { id } = challengeMetaSelector(state);
  return completedPercentage === 100 && !completedChallengesIds.includes(id);
};

export const attemptsSelector = state => state[ns].attempts;
export const canFocusEditorSelector = state => state[ns].canFocusEditor;
export const visibleEditorsSelector = state => state[ns].visibleEditors;
export const showPreviewPortalSelector = state => state[ns].showPreviewPortal;
export const showPreviewPaneSelector = state => state[ns].showPreviewPane;

export const challengeAnswersSelector = state => state[ns].challengeAnswers;

export const isCompletedChallengesLoading = state =>
  state[ns].completedChallengesLoading;

export const currentChallengeSelector = state => state[ns].challenge;
export const challengeIndexForSuperBlockSelector = state =>
  state[ns].challengeIndexForSuperBlock;

export const isAiAssistantOpenSelector = state =>
  state[ns].chatAssistant.isOpen;

export const selectChatAssistantSessionId = state => {
  return state[ns].chatAssistant.sessionId;
};

export const selectChatHistory = state => {
  return state[ns].chatAssistant.history;
};

export const selectChatAssistantTyping = state => {
  return state[ns].chatAssistant.typing;
};

export const showModalDeleteHistory = state => {
  return state[ns].chatAssistant.modalDeleteHistory;
};

export const chatAssistantErrorSelector = state => {
  return state[ns].chatAssistant.error;
};

export const chatAssistantAdditionalContextSelector = state => {
  return state[ns].chatAssistant.additionalContext;
};
